import { makeStyles } from '@rbx/ui';

const useShareFeedbackStyles = makeStyles()((theme) => ({
  container: {
    width: 600,
    maxWidth: '100%',
    margin: '0 auto',
    background: theme.palette.background.media,
  },

  textarea: {
    margin: theme.spacing(1, 0),
  },

  textareaOutline: {
    borderColor: 'red',
  },

  feedbackPublicCheckbox: {
    paddingBottom: theme.spacing(0.5),
    '& .MuiCheckbox-root:not(.Mui-checked) .MuiSvgIcon-root': {
      fill: theme.palette.action.disabled,
    },
  },

  feedbackPublicCheckboxLabel: {
    color: theme.palette.content.muted,
  },

  viewGuidelines: {
    color: theme.palette.content.muted,
  },

  headerIcon: {
    marginRight: theme.spacing(2),
  },

  buttonIcon: {
    marginRight: theme.spacing(1),
  },

  actions: {
    justifyContent: 'flex-end',
    paddingRight: theme.spacing(3),
    '& button:disabled': {
      '& .MuiCircularProgress-root': {
        display: 'none',
      },
    },
  },
}));

export default useShareFeedbackStyles;
